export default __webpack_public_path__ + "static/media/image.ostrio-ceylon-private-limited.6c1a029a.png";